module.exports = __webpack_public_path__ + "img/help-circle.07de92b3.svg";